import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermCondition from "./pages/term-condition";
import ShippingPolicy from "./pages/shippingPolicy";
import RefundPolicy from "./pages/refundPolicy";
function App() {
  return (
    <div className="App">

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/termCondition" element={<TermCondition />} />
        <Route path="/contactUs" element={<Contact />} />
        <Route path="/shippingPolicy" element={<ShippingPolicy />} />
        <Route path="/refundPolicy" element={<RefundPolicy />} />
      </Routes>

    </div>
  );
}

export default App;
